import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const CreateOrganization = async (
  name,
  slug,
  email,
  countryCode,
  phone,
  address,
  status,
  image
) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.CREATE_ORGANIZATION,
    {
      name,
      slug,
      email,
      countryCode,
      phone,
      image,
      address,
      status
    }
  );
  return response;
};

export const GetAllOrganinazations = async (pageNo, limit) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.GET_ORGANIZATION_LIST}?page=${pageNo}&limit=${limit}`
  );
  return response;
};

export const CreateUserInOrganization = async (
  organizationId,
  name,
  email,
  password,
  phone,
  role,
  zone
) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION,
    {
      email,
      password,
      organizationId,
      name,
      phone,
      role,
      zonePath: zone
    }
  );
  return response;
};
export const GetOrganizationDetailsById = async (organizationId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.GET_ORGANIZATION_LIST}/${organizationId}`
  );
  return response;
};
export const SetupOrganizationConfig = async (
  organizationId,
  offlineCheckDuration,
  allowNoOfTriggers
) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.SETUP_ORGANIZATION_CONFIG,
    {
      organizationId,
      offline_check_duration: offlineCheckDuration,
      allow_number_of_trigger_in_day: allowNoOfTriggers
    }
  );
  return response;
};

export const GetAllOrganinazationUser = async (pageNo, limit, where) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION}?page=${pageNo}&limit=${limit}`,
    {
      params: {
        where: JSON.stringify(where)
      }
    }
  );
  return response;
};

export const GetOrganizationDeviceStats = async () => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.DASHBOARD_STATS);
  return response;
};

export const GetAllOrganizationMerchantStatsAsSuperAdmin = async () => {
  const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.DASHBOARD_STATS);
  return response;
};

export const GetOrganizationTransactionStats = async (fromDate, toDate) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.TRANSACTION_STATS, {
    params: {
      startDate: fromDate,
      endDate: toDate
    }
  });
  return response;
};

export const GetTransactionHistory = async (pageNo, limit, where, startDate, endDate) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.TRANSATION_LIST}?limit=${limit}&page=${pageNo}`,
    {
      params: {
        where: JSON.stringify(where),
        ...(startDate && { startDate }),
        ...(endDate && { endDate })
      }
    }
  );
  return response;
};

export const OrganizationBranchesBulkUpload = async (file, organizationId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('organizationId', organizationId);
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.ORG_BRANCHES_BULK_UPLOAD,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response;
};

export const GetOrganizationNotifications = async (organizationId) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.NOTIFICATION_HISTORY,
    {
      organizationId
    }
  );
  return response;
};

export const GetOrganizationMerchantStats = async () => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.ORG_MERCHANT_STATS);
  return response;
};


export const GetTransactionsTrend = async (startDate, endDate) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_TRANSACTION_TREND}?startDate=${startDate}&endDate=${endDate}`,
    {}
  );
  return response;
};